export const FILTER_SECTION = {
    genderFilter: "section-gender",
    saleFilter: "section-discount-from",
    brandFilter: "section-designer-slug",
    categoryFilter: "section-category",
    sizeFilter: "section-sizes",
    priceFilter: "section-final-price",
    colorFilter: "section-color",
    moreFilter: "section-more-filters",
    shippingFilter: "section-shipping",
    materialFilter: "section-material",
    retailerFilter: "section-retailer-slug",
} as const;
